import { colors } from './colors'
import { fonts } from './fonts'

export const tokens = {
  colors,
  fonts,
}
